module.exports = __webpack_public_path__ + "static/image_fallback-a8deedad0fa6c8e6f3fa83cc5c21072e.png";